import React, { FC } from 'react';

import { Label } from './styled';

const InputLabel: FC<{ autoCapitalize?: boolean }> = ({ children, autoCapitalize = false }) => (
  <Label variant="badge" $autoCapitalize={autoCapitalize}>
    {children}
  </Label>
);

export default InputLabel;
